export default __webpack_public_path__ + "static/media/delivery-koinz-orange.43dd33fa.svg";